import { useEffect } from 'react'
import { getUserWallet } from '../adapters/user'
import { navigate } from 'gatsby'
import { EnvConfig } from '../config/EnvConfig'
import { usePaymentDrawerContext } from '../context/paymentDrawerProvider'
import { oryxGameProvidersSupportingCashierEvent } from '../utils/constants'

export const useGameEventHandling = (
  casinoProvider,
  providerSlug,
  isCasinoGameWalletPullingEnabled,
  depositSlug,
  casinoBackLink
) => {
  const { open, isOpen } = usePaymentDrawerContext()

  useEffect(() => {
    let eventHandler
    switch (casinoProvider) {
      case 'ORYX':
        eventHandler = handleOryxEvents
        break
      case 'PLAYTECH':
        eventHandler = handlePlaytechEvents
        break
      default:
        eventHandler = null
    }
    if (!eventHandler) return

    window.addEventListener('message', eventHandler)

    return () => {
      window.removeEventListener('message', eventHandler)
    }
  }, [casinoProvider, isCasinoGameWalletPullingEnabled])

  const handlePlaytechEvents = (event) => {
    if (typeof event.data === 'string') {
      const parsedEventData = JSON.parse(event.data)
      const iframe = document.getElementById('game')
      if (parsedEventData._type === 'ucip.basic.g2wCloseGameFrameCommand') {
        navigate('/')
      }

      if (parsedEventData._type === 'ucip.openpage.g2wOpenPageCommand') {
        if (parsedEventData.pageID !== 'deposit') return
        navigate(`/${depositSlug}`)
      }

      if (parsedEventData._type === 'ucip.basic.g2wInitializationRequest') {
        const response = JSON.stringify({
          _type: 'ucip.basic.w2gInitializationResponse',
          version: '1.0.7',
          features: [['openpage', { delegatePages: ['deposit'] }]],
        })

        iframe.contentWindow.postMessage(response, '*')
      }
    }
  }

  const handleOryxEvents = (event) => {
    if (
      event?.data?.type === 'Window.Redirect' &&
      event?.data?.url === `${EnvConfig.SITE_URL}/`
    ) {
      navigate('/')
      return
    }

    if (event?.data?.rgMessage === 'gprg_Listening') {
      event.source.postMessage({ rgMessage: 'oprg_Ready' }, '*')
    }

    if (
      event?.data?.rgMessage === 'gprg_UserAction' &&
      event?.data?.payload?.action === EnvConfig.SITE_URL
    ) {
      navigate('/')
    }

    if (
      event?.data?.wpgaction === 'gameSpinEnd.parent' &&
      isCasinoGameWalletPullingEnabled
    ) {
      getUserWallet()
    }

    if (
      event?.data?.wpgaction === 'cashier' &&
      oryxGameProvidersSupportingCashierEvent?.includes(providerSlug)
    ) {
      !isOpen && open()
    }

    if (event?.data?.wpgaction === 'close') {
      navigate(casinoBackLink)
    }
  }
}
